import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { reviewSettingAdditionalCommentData } from "../../sample-data";

const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchReviewSettingAdditionalComment = createAsyncThunk(
  "ReviewSettingAdditionalComment/fetchReviewSettingAdditionalComment",
  async (thunkApi, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    
    return reviewSettingAdditionalCommentData;
    try {
      const response = await axios.get(url, {
        validateStatus: (status) => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReviewSettingAdditionalComment = createSlice({
  name: "ReviewSettingAdditionalComment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewSettingAdditionalComment.pending, (state) => {
        state.data = [];
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(
        fetchReviewSettingAdditionalComment.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = ""; // Reset error on successful fetch
        }
      )
      .addCase(
        fetchReviewSettingAdditionalComment.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
          console.log(state.error);
        }
      );
  },
});

export const selectReviewSettingAdditionalCommentData = (state) =>
  state.ReviewSettingAdditionalComment.data;
export const selectIsLoading = (state) =>
  state.ReviewSettingAdditionalComment.isLoading;
export const selectError = (state) =>
  state.ReviewSettingAdditionalComment.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.ReviewSettingAdditionalComment.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.ReviewSettingAdditionalComment.data,
  isLoading: state.ReviewSettingAdditionalComment.isLoading,
  error: state.ReviewSettingAdditionalComment.error,
}));
*/
export default sliceReviewSettingAdditionalComment.reducer; // Export the reducer
